<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-21 14:43:06
 * @LastEditTime: 2022-10-21 16:47:03
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/list.vue
 *
-->
<template>
  <div class="wrapper">
    <div class="head-bg">
      <!-- 头部搜索组件 -->
      <van-sticky :z-index="10">
        <search
          ref="search"
          :select="select"
          @backHander="backHander"
          @changeParentData="getDataByTag"
          @endMonthsAge="endMonthsAge"
          @inputFocusHander="inputFocusHander"
        />
      </van-sticky>
      <!-- 独家策划 -->
      <exclusive-panning
        :exclusivePanningList="exclusivePanningList"
        @toSpecialTopic="toSpecialTopic"
      />
      <!-- 编辑推荐 -->
      <edit-recommend
        :editRecommendList="editRecommendList"
        @toDetails="toDetails"
      />
    </div>
    <!-- 列表导航 -->
    <van-sticky
      v-if="showListNav"
      :offset-top="searchHeight"
      :z-index="1"
      @change="searchChang"
    >
      <div class="list-nav">
        <van-tabs v-model="navActiveTag" @click="navCheck">
          <van-tab
            :disabled="isNavDisabled"
            name="0"
            title="奶娃宝典"
          ></van-tab>
          <!-- <van-tab
            :disabled="isNavDisabled"
            name="1"
            title="儿歌故事"
          ></van-tab> -->
        </van-tabs>
      </div>
    </van-sticky>
    <!-- 数据列表 -->
    <div class="content-list">
      <!-- 滚动分类 -->
      <classification
        ref="tabClassification"
        :activeTagID="activeTagID"
        :isDisabled="isDisabled"
        :navHeight="navHeight"
        :searchHeight="searchHeight"
        :tagList="tagList"
        :tagListTitle="tagListTitle"
        @changeTab="checkClassification"
      />
      <!-- 儿歌故事增加滚动分类标签 -->
      <songClassification
        v-if="navActive && articleId > 0 && songTagList.length > 0"
        :navHeight="navHeight"
        :searchHeight="searchHeight"
        :songTagActiveId="songTagActiveId"
        :songTagHeight="songTagHeight"
        :tagList="songTagList"
        @showSongClassification="showSongClassification"
        @switchSongTag="switchSongTag"
      />

      <!-- 瀑布流内容 -->
      <div class="content">
        <van-list
          v-if="tagList.length > 1"
          v-model="pageWikipediaParams.loading"
          :error.sync="pageWikipediaParams.error"
          :finished="pageWikipediaParams.finished"
          :finished-text="pageWikipediaParams.bottomText"
          :immediate-check="false"
          error-text="请求失败，点击重新加载"
          @load="onLoad(articleId)"
        >
          <waterfallComponents
            ref="waterfall"
            class="water-fall"
            @clickHander="clickHander"
            @styleEnd="styleEnd"
          >
          <!-- // 0凯琪育儿  1育儿音频  2奶娃百科 ||儿歌动画 3推广活动 -->
          <!-- //更改 2凯琪育儿  3育儿音频  1奶娃百科  19推广活动  4儿歌动画 -->
            <template slot-scope="props">
              <div :class="props.data.jumpType?'water-burial-point':''" :databanner="JSON.stringify({...resourceNiche(props.data),xmh5_ziyuanwei_position: props.index+1})">
              <div :data="JSON.stringify(props.data)" class="info">
                <div
                  v-lazy:background-image="
                    props.data.imgUrl || props.data.coverUrl
                  "
                  :style="
                    props.data.columnId <= 3
                      ? 'height:167px;'
                      : props.data.columnId == 0
                      ? 'height:165px;'
                      : 'height:167px;'
                  "
                  :class="['info-img',props.data.jumpType?'info-radius jumpHeight':'']"
                >
                  <i
                    v-if="
                      !props.data.jumpType && (!navActive ? props.data.columnId == 1 || props.data.columnId == 4 || props.data.columnId == 19 ? false : true : props.data.columnId != 19)
                    "
                    alt=""
                    class="play-btn"
                  ></i>
                </div>
                <template v-if="props.data.jumpType === 3">
                  <div class="information-wxtag">
                    <openWxTag
                        :id="'information'+props.data.id"
                        :path="props.data.jumpTargetUrl"
                        :appId="props.data.miniProgramTypeAppId"
                        btnStyle="width:100%;height:300px"
                    ></openWxTag>
                  </div>
                </template>
                <div class="bottom-content" v-if="props.data.jumpType && props.data.resTitle">
                  <p class="item-title res_title">
                    {{ props.data.resTitle }}
                  </p>
                </div>
                <div class="bottom-content" v-if="!props.data.jumpType">
                  <p class="item-title">
                    {{ props.data.title || props.data.name }}
                  </p>
                  <div v-if="props.data.tagName" class="item-tagAndPlaynum">
                    <span class="item-tag">{{ props.data.tagName }}</span>
                    <p class="item-playnum">
                      <img
                        class="icon"
                        src="@/assets/images/expertsView/play.png"
                      />
                      <span>{{
                        props.data.columnId=== 1 ? fomatterNum(props.data.playNum ||props.data.clickNum ):fomatterNum(props.data.watchNum)
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
              </div>
            </template>
          </waterfallComponents>
          <template #finished>
            <img
              src="@/assets/images/expertsView/pentagram.png"
              style="width: 9px"
            />
            我们会加油更新的 么么哒~
            <img
              src="@/assets/images/expertsView/pentagram.png"
              style="width: 9px"
            />
          </template>
        </van-list>
      </div>
    </div>
    <!-- 儿歌故事分类选择弹窗 -->
    <chooseSongClassification
      :showSong="showSong"
      :songTagActiveId="songTagActiveId"
      :tagList="songTagList"
      @showSongClassification="showSongClassification"
      @switchSongTag="switchSongTag"
    />
    <!-- 京城名医视频 -->
    <foodVedio
      ref="childVideo"
      :showVedio="showVideo"
      :videoDetail="doctorInfo"
      :videoId="doctorInfo.id"
      :isShowComment="isShowComment"
      getContainer="#HorizontalScreen"
      isHfindex="true"
      @hideVedio="hideVideoEvent"
      @isUserLogin="isUserLogin"
    />
  </div>
</template>
<script>
//组件
import search from "@/components/contents/searchCommon/monthSearch.vue"; //搜索组件
import exclusivePanning from "./components/exclusivePanning.vue"; //独家策划
import editRecommend from "./components/editRecommend.vue"; //编辑推荐
import waterfallComponents from "@/components/contents/waterfallComponents.vue"; //瀑布流
import classification from "./components/classification.vue"; // 滚动分类组件
import songClassification from "./components/songClassification.vue"; // 儿歌故事新增的分类标签
import chooseSongClassification from "./components/chooseSongClassification.vue"; // 儿歌故事选择分类弹窗
import foodVedio from '@/views/contents/bjfamousdoctor/component/video.vue' //京城名医视频播放
import openWxTag from "@/components/common/openWeappTag/index.vue";
// 方法
import { fomatterNum, getCookie, isUserLogin,Debounce,advertisJump,resourceNiche } from "@/assets/js/common.js";
import { babyWikipedia_content } from "@/assets/js/Exposure";
import {
  BuiedPointClick_Fn,
  Exposurer_babyList_Fn, xmhziyuanwei_data_expo,
} from "@/assets/js/BuriedPointEvent";

export default {
  name: "wikipediaList",
  data() {
    return {
      classFlag: false, //全部分类展示
      tagListTitle: [],
      searchHeight: 0, //搜索框高度
      navHeight: 0, //nav高度
      dataList: [],
      list: [],
      isClick: true,
      pageWikipediaParams: {
        page: 1,
        size: 25,
        error: false,
        loading: false,
        bottomText: "",
        finished: false,
      }, // 分页配置参数
      tagList: [], //tab选项卡 文章分类列表 所有二级标签
      userInfo: {}, //用户信息
      periodid: 0, //月龄id
      babybirth: "", // 宝宝生日
      select: "全部", // 月龄名称
      articleId: -1, //初始化文章id为热门-1 //一级分类
      isDisabled: false,
      navActive: 0, // 当前选择的nav大模块
      exclusivePanningList: [], //独家策划
      editRecommendList: [], // 编辑推荐列表
      showListNav: false, // 导航nav显示
      positioning: 0, // 分类下拉定位的距离
      suckTheTop: false, // 是否吸顶
      isNavDisabled: false, // nav导航是否可以点击
      classifyName: "热门",
      showSong: false, // 儿歌分类选择展示
      songTagList: [], // 儿歌新增分类数据
      navActiveTag: "", // 两个跳转链接的匹配
      isFirstOpen: true, //两个链接跳转不同模块 判断是否是首次进入
      songTagHeight: 0, //新增儿歌标签的高度
      songTagActiveId: 0, //儿歌标签当前选中id
      activeTagID: 0,
      handleObj: {},
      showVideo:false,
      isShowComment: false,
      doctorInfo:{}
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit("changeIncludes", [
        "home",
        "babyFeedingIndex",
        "babyFeeding",
        "wikipediaIndex",
        "wikipediaList",
      ]);
      vm.handleObj.watchNum = vm.$store.state.isaddNum ? vm.handleObj.watchNum + 1 : vm.handleObj.watchNum
      // 小程序星妈会没有播放音频的资质，先统一获取奶娃宝典的
      vm.navActiveTag = "0";
      vm.navActive = 0;
      // vm.getArticlClassify();
      // 小程序星妈会没有播放音频的资质，先注释掉，后续会放开
     // if (vm.$route.query.from == "milkEva") {
      //   vm.navActiveTag = "0";
      //   vm.navActive = 0;
      //   vm.getArticlClassify();
      // } else if (vm.$route.query.from == "song") {
      //   if (!from.name || from.name == "parentchildsongsdetail") {
      //     // link 进来 name就没值或或为儿歌动画详情进来
      //     if (vm.$route.query.navActive) {
      //       vm.navActiveTag = "1";
      //       vm.activeTagID = vm.$route.query.navActive;
      //       vm.$refs.tabClassification.active = 2;
      //       vm.navActive = Number(vm.$route.query.navActive);
      //     } else {
      //       vm.navActiveTag = "1";
      //       vm.navActive = 1;
      //     }
      //     vm.onLoad();
      //   } else if (from.name == "BabyDetail") {
      //     // 奶娃宝典的详情
      //     vm.navActiveTag = "0";
      //     vm.navActive = 0;
      //     vm.getArticlClassify();
      //     vm.onLoad(-1);
      //   }else {
      //     vm.navActiveTag = "1";
      //     vm.navActive = 1;
      //     vm.onLoad();
      //   }
      // }
    });
  },
  components: {
    search,
    exclusivePanning,
    editRecommend,
    waterfallComponents,
    classification,
    songClassification,
    chooseSongClassification,
    foodVedio,
    openWxTag
    // messagelist
  },

  computed: {},

  created() {
    this.initPage();
  },
  mounted() {
    var shareDataParams = {
      // shareLink: this.$http.hostName + "/home",
      shareLink: location.href.split("#")[0],
      shareDesc:
        "护理、早教、营养，星妈会2000篇+文章，养娃的方方面面知识，这里一搜就有！",
      shareTitle: "星育儿",
      imgUrl: "https://image-mom.feihe.com/wxshare/yunyubaike.png", //必须是绝对路径
    };
    var that = this;
    that.wxJsSet.wxShare("fx", shareDataParams, that);

    //初始化下拉分类
    this.$nextTick(() => {
      $(".tagAllList").delay(50).slideDown(300);
      $(".tagAllList").slideUp(300);
    });
  },

  methods: {
    resourceNiche,
    isUserLogin,
    fomatterNum,
    getCookie,
    // 视频播放返回按钮
    hideVideoEvent() {
      // document.title = '星妈会首页'
      // this.isShowComment = false
      this.showVideo = false
    },
    // 页面初始化
    initPage() {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.getExclusivePanning(); // 独家策划
      // this.getSongClassification();
      // 判断是否有用户信息
      if (this.userInfo != "" && this.userInfo != null) {
        this.getMemberInfo(); //获取用户信息
      } else {
        this.periodid = 0;
        // this.getArticlClassify(); //获取列表分类
      }
    },
    // 月龄获取完毕
    endMonthsAge() {
      var babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
      if (babyInfo) {
        let currentBaby = this.getCookie("babyNum");
        let currentBabyInfo = babyInfo;
        if (currentBaby) {
          currentBabyInfo = babyInfo.filter((item) => {
            return item.num == currentBaby;
          });
        }
        // let babyIndex = babyInfo.findIndex((item, index) => {
        //   return item.num == currentBaby;
        // });
        // console.log("")
        console.log("宝宝信息",babyInfo, currentBabyInfo, currentBaby);
        this.periodid = currentBabyInfo[0].tag_id;
        this.babybirth = currentBabyInfo[0].birth;
        if (this.periodid == 1) {
          this.periodid = 2;
        } else if (this.periodid == 2) {
          this.periodid = 1;
        }
        this.select = this.$refs.search.optionList[this.periodid].name;
        this.periodid = this.$refs.search.optionList[this.periodid].id;
      } else {
        this.periodid = "0";
        this.select = "全部";
        this.babybirth = "";
      }
      localStorage.setItem("currentMonth", this.select);
      // 不是链接跳转过来的调用请求分类接口
      this.getArticlClassify(); //获取列表分类
      // 小程序星妈会没有播放音频的资质，先注释掉，后续会放开
      // if (
      //   !this.$route.query.from ||
      //   (this.$route.query.from != "milkEva" &&
      //     this.$route.query.from != "song")
      // ) {
      //   this.getArticlClassify(); //获取列表分类
      // }
    },
    // 获取热门文章
    // articleHot(tagId) {
    //   let babyNums = localStorage.getItem("babyNums");
    //   let babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
    //   let babyBirthDay =
    //     (babyInfo && babyInfo[babyNums - 1] && babyInfo[babyNums - 1].birth) ||
    //     ""; // 当前宝宝生日
    //   let BirthDay =
    //     (babyInfo && babyInfo[babyNums - 1] && babyInfo[babyNums - 1].birth) ||
    //     "null"; // 当前宝宝生日
    //   if (
    //     babyInfo &&
    //     babyInfo[babyNums - 1] &&
    //     babyInfo[babyNums - 1].tag_id == 1
    //   ) {
    //     BirthDay = "备孕";
    //   }
    //   let data = [];
    //   this.$http.get(
    //     "/articleResource/resourceList",
    //     { babyBirthDay: BirthDay },
    //     (res) => {
    //       data = res.data == null ? [] : res.data;
    //       if (res.code == 200) {
    //         this.articleHotList = data;
    //         // 获取列表数据
    //         this.onLoad(this.articleId);
    //       }
    //       // this.navActive = 0
    //     }
    //   );
    // },
    // 当导航到达吸顶
    searchChang(e) {
      if (e) {
        this.suckTheTop = true;
        $(".list-nav").css({ backgroundColor: "#FFFFFF" });
        $(".fixed").css({ backgroundColor: "#FFFFFF" });
        $(".month_search").css({ backgroundColor: "#FFFFFF" });
      } else {
        this.suckTheTop = false;
        $(".month_search").css({ backgroundColor: "#FFB2DE" });
        $(".list-nav").css({ backgroundColor: "transparent" });
      }
    },

    //获取用户信息
    getMemberInfo() {
      // this.$http.get(
      //   "/babyWikiRevision/memberInfoByCrmId",
      //   { crm_id: this.userInfo.crm_id },
      //   (res) => {
      //     if (res.code === "200") {
      //       if (res.data.id == 6) {
      //         this.select = "3岁以上";
      //         this.periodid = 0;
      //       } else if (res.data.id == 0) {
      //         this.select = "全部";
      //         this.periodid = 0;
      //       } else {
      //         this.select = res.data.name;
      //         this.periodid = res.data.id;
      //       }
      //     } else {
      //       this.select = "全部";
      //       this.periodid = 0;
      //     }
      //     this.getArticlClassify(); //获取列表分类
      //   }
      // );
    },
    // 点击月龄
    getDataByTag(name, id, flag) {
      this.sensorsFn("月龄切换");
      this.tagList = [];
      this.dataList = [];
      this.songTagActiveId = 0; // 儿歌故事下分类选中第一个
      this.pageWikipediaParams.page = 1;
      this.pageWikipediaParams.loading = false;
      this.pageWikipediaParams.finished = false;
      this.$refs.waterfall && this.$refs.waterfall.resetDefaultData();
      this.select = name;
      this.periodid = id;
      this.$refs.tabClassification.active = 0;
      this.articleId = -1;
      console.log(this.navActive, 'navActive')
      // 儿歌故事不需要请求分类
      if (this.navActive) {
        // this.getSongClassification()
        this.getSong(this.articleId);
      } else {
        this.getArticlClassify();
      }
    },
    //获取分类标签
    getArticlClassify() {
      this.tagList = [];
      this.tagListTitle = [];
      this.$http.get(
        "/content/tag/getTagTreeByMonthId",
        {
          id: this.periodid,
          columnId: 1,
          isChangeTree: true,
          isHaveParent: true,
          setTreeDeep: 2,
        },
        async (res) => {
          if (res.code === 200) {
            if (res.data.length) {
              // 设置分类列表加载Dom 渲染完成
              for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].parentId == res.data[i].parentId) {
                  this.tagListTitle.push(res.data[i]);
                  console.log(this.tagListTitle, "this.tagListTitle");
                }
                for (var j = 0; j < res.data[i].children.length; j++) {
                  this.tagList.push(res.data[i].children[j]);
                }
                console.log(this.tagList, res, " this.tagList");
              }

              //  拿到季节  (已改需求 以下代码注释是目前不使用了)
              // let season = [];
              // this.tagList.forEach((item, index) => {
              //   if (
              //     item.name == "春季" ||
              //     item.name == "夏季" ||
              //     item.name == "秋季" ||
              //     item.name == "冬季" ||
              //     item.name == "四季"
              //   ) {
              //     season.push(item);
              //   }
              // });
              // var filterTag = [];
              //  过滤调季节
              // this.tagList.filter((item) => {
              //   if (item.name != "四季" && item.sort > 4) {
              //     filterTag.push(item);
              //   }
              // });
              // this.tagList = filterTag;
              //  给获取到的季节从大到小排序
              // season.sort((a, b) => {
              //   return a.sort - b.sort;
              // });
              // var monthFirst = [];
              // var currentName = await this.scoreLevel();
              // console.log('currentName', currentName)
              // season.forEach(async (item, index) => {
              //   // console.log('item.name', item.name)
              //   if (item.name == currentName) {
              //     monthFirst = season[index];
              //     season[index] = season[0];
              //     season[0] = monthFirst;
              //   }
              // });
              // console.log("season", season);
              // var tagThree = season.slice(1);
              // console.log("tagThree", tagThree);
              // tagThree.sort(function (a, b) {
              //   return a.sort - b.sort;
              // });
              // var arrOne = season.slice(0, 1);
              // tagThree.unshift(...arrOne);
              // this.tagList.unshift(...tagThree);
              // console.log(tagThree);
              var hotContent = { name: "热门", id: -1, parentId: -1 };
              this.tagList.unshift(hotContent);
              console.log("this.tagList", this.tagList);
              console.log(this.tagList[0].id, 'tagListtagListtagListtagList')
              this.getArticleList(this.tagList[0].id)
              // 获取热门文章
              // this.articleHot(-1);
              this.$nextTick(() => {
                $(".isDisabled .van-tab").removeClass("van-tab--disabled");
              });
            }
          }
        },
        (err) => {},
        "lucky"
      );
    },
    // 切换分类点击
    checkClassification(tagId) {
      // 点击不同分类再请求
      if (this.articleId != tagId.id) {
        // $(".content").css("min-height", "100%");
        this.isDisabled = true; //点击请求列表数据 数据未请求成功之前禁止继续切换分类
        this.articleId = tagId.id;
        this.$refs.waterfall && this.$refs.waterfall.resetDefaultData();
        this.pageWikipediaParams.page = 1;
        this.dataList = [];
        this.pageWikipediaParams.loading = true;
        this.pageWikipediaParams.finished = false;
        this.classifyName = tagId.name;
        // navActive true 儿歌故事 false 奶娃宝典
        if (this.navActive) {
          this.songTagActiveId = 0;
          this.sensorsFn("儿歌故事", "", "", "", tagId.name);
          this.getSong(this.articleId);
          // 不是最新推荐可以埋点
          if (tagId.id) {
            sensors.track("home_yunyubaike_tagfloor_more", {
              avtag_classification: tagId.name,
            });
            sensors.track("home_yunyubaike_tagfloor_show", {
              avtag_classification: tagId.name,
            });
          }
          // 判断不是最新推荐的时候请求儿歌分类
          if (tagId.id != 0) {
            this.getSongClassification(); //请求儿歌故事分类标签
          }
        } else {
          this.sensorsFn("奶娃宝典", "", "", tagId.name);
          // if (this.articleId != -1) {
            this.onLoad(this.articleId);
          // } else {
          //   // this.articleHot(this.articleId);
          // }
        }

        this.$nextTick(() => {
          // 处于吸顶状态的时候点击分类切换固定状态
          if (this.suckTheTop) {
            $(window).scrollTop(this.positioning + 1);
          } else {
            $(".content").css("min-height", "100%");
          }

          // disabled状态清除禁用样式
          $(".isDisabled .van-tab").removeClass("van-tab--disabled");
        });
      }
    },
    // 获取某一年某个节气日期
    // y年的第n个节气点时点的int值
    getTermDate(y, n) {
      var solarTerm = ["立春", "立夏", "立秋", "立冬"];
      var sTermInfo = [42467, 173149, 308563, 440795];
      // 31556925974.7为地球公转周期，是毫秒。（如果换算成天，是265.242199天，所以每四百年就有97个闰年，同样，我们也可以看到，如果这样做的话，一百三十万年后，我们的公历算法将有一天的误差）
      // ( 31556925974.7*(y-1900) + sTermInfo[n]*60000 )----表示y年的第n个节气点（15倍数度点）距1900年的小寒点的毫秒数
      // Date.UTC(1900,0,6,2,5)----表示1900年一年六日两点五分是正小寒点。
      return new Date(
        31556925974.7 * (y - 1900) +
          sTermInfo[n] * 60000 +
          Date.UTC(1900, 0, 6, 2, 5)
      );
    },
    // 策略提取当前月季
    async scoreLevel() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var solarTerm = ["春季", "夏季", "秋季", "冬季"];
      var scoreLevelObj = {};
      // 获取5年内的"立春","立夏","立秋","立冬"节气
      for (let startYear = year; startYear <= year + 5; startYear++) {
        for (let i = 0; i < solarTerm.length; i++) {
          // 某个节气的开始日期
          var sterm = await this.getTermDate(startYear, i);
          var stdateStr =
            sterm.getFullYear() +
            "/" +
            (sterm.getMonth() + 1).toString().padStart(2, 0) +
            "/" +
            sterm.getUTCDate().toString().padStart(2, 0);
          // 某个节气的结束日期
          var stermEnd = await this.getTermDate(
            i == 3 ? startYear + 1 : startYear,
            i == 3 ? 0 : i + 1
          );
          var stdateEndStr =
            stermEnd.getFullYear() +
            "/" +
            (stermEnd.getMonth() + 1).toString().padStart(2, 0) +
            "/" +
            (stermEnd.getUTCDate() - 1).toString().padStart(2, 0);
          // 添加到对象中
          scoreLevelObj[startYear + "&" + solarTerm[i]] = [
            stdateStr,
            stdateEndStr,
          ];
          // 特殊处理，由于算法的误差
          if (startYear == 2023 && i == 3) {
            scoreLevelObj["2023&冬季"][0] = "2023/11/08";
            scoreLevelObj["2023&秋季"][1] = "2023/11/07";
          }
        }
      }
      console.log(scoreLevelObj);
      // 获取年月日
      const currentDate =
        year +
        "/" +
        month.toString().padStart(2, 0) +
        "/" +
        day.toString().padStart(2, 0);
      console.log("currentDate", currentDate);
      // const obj = {
      //   '春季': ['2022/02/03', '2022/05/04'],
      //   '夏季': ['2022/05/05', '2022/08/06'],
      //   '秋季': ['2022/08/07', '2022/11/06'],
      //   '冬季': ['2022/11/07', '2023/02/02'],
      // }
      var season = "";
      for (var key in scoreLevelObj) {
        if (
          scoreLevelObj[key][0] <= currentDate &&
          currentDate <= scoreLevelObj[key][1]
        ) {
          season = key;
        }
      }
      return season.split("&")[1];

      // return {
      //   3: "春季",
      //   4: "春季",
      //   5: "春季",
      //   6: "夏季",
      //   7: "夏季",
      //   8: "夏季",
      //   9: "秋季",
      //   10: "秋季",
      //   11: "秋季",
      //   12: "冬季",
      //   1: "冬季",
      //   2: "冬季",
      // }[score];
    },
    onLoad(articleId) {
      // true 为儿歌故事
      if (this.navActive) {
        this.getSong();
      } else {
        this.getArticleList(articleId);
      }
    },
    styleEnd() {
      this.pageWikipediaParams.loading = false;
    },
    // 获取文章列表
    getArticleList(tagId) {
      this.pageWikipediaParams.loading = true;
      if (typeof tagId == "object") {
        var tagId = tagId.id;
        this.dataList = [];
        this.$refs.waterfall && this.$refs.waterfall.resetDefaultData();
        this.pageWikipediaParams.page = 1;
        this.pageWikipediaParams.loading = true;
        this.pageWikipediaParams.finished = false;
      }
      const babyInfo = JSON.parse(localStorage.getItem('babyInfo'))
      // 当前点击的分类id
      this.articleId = tagId;
      // 当选中的月龄与当前宝宝的月龄相等时，或者选择全部时，将当前宝宝的生日传给后端，否则是‘’
      let babyBirthDay =
        this.select == localStorage.getItem("currentMonth") ||
        this.select == "全部"
          ? this.babybirth
          : "";
      this.$http.post(
        "/content/flow/milkPageFlow",
        {},
        {
          // data: {
          tagId: this.periodid,
          contentTagId: [tagId],
          isCustomized: babyInfo && babyInfo.length ? true: false,
          // babyBirthDay: babyBirthDay,
          crmId:
            this.userInfo != null
              ? this.userInfo.crm_id
              : this.getCookie("xmh_unionid"),
          // },
          pageNum: this.pageWikipediaParams.page,
          pageSize: this.pageWikipediaParams.size,
        },
        (res) => {
          if (res.code == 200) {
            console.log(res, "this.articleHotList");
            this.isDisabled = false; //获取数据成功可以切换分类
            this.isNavDisabled = false;
            const { data, total } = res.data;
            console.log(data, total, "content111");
            this.dataList = [...this.dataList, ...data];
            console.log(...data, "pageSize");
            if (
              this.dataList.length >
              this.pageWikipediaParams.pageSize
            ) {
              this.$refs.waterfall.initData("push", data);
            } else {
              this.$refs.waterfall.initData("init", this.dataList);
            }
            this.$nextTick(() => {
              if (this.dataList.length >= total) {
                this.pageWikipediaParams.finished = true;
              } else {
                this.pageWikipediaParams.page += 1;
                // this.pageWikipediaParams.loading = false;
              }
              setTimeout(() => {
                // 判断是否首次进入页面
                if (this.isFirstOpen) {
                  this.isFirstOpen = false;
                  if (this.$route.query.from == "milkEva")
                    $(window).scrollTop(this.positioning + 1);
                }
              });
            });
            // 神策曝光埋点
            setTimeout(() => {
              xmhziyuanwei_data_expo.observe(
                  "xmh5_ziyuanwei_view",
                  ".water-burial-point",
                  false
              );
              babyWikipedia_content.observe(".info", false, {
                classification:
                  this.$refs.tabClassification.activeName || "热门",
                navActive: this.navActive,
              });
              Exposurer_babyList_Fn.observe(
                "NewsShown",
                ".water-fall-item",
                false
              );
            }, 300);
          } else {
            this.$toast("网络异常");
            this.pageWikipediaParams.loading = false;
            this.pageWikipediaParams.error = true;
            this.isDisabled = false;
          }
        },
        (err) => {},
        "lucky"
      );
    },
    // nav大模块点击
    navCheck(index) {
      // 点击不同分类再请求
      if (this.navActive != index) {
        this.isNavDisabled = true;
        this.tagList = [];
        this.dataList = [];
        this.$refs.tabClassification.active = 0; //初始化分类选中
        this.pageWikipediaParams.page = 1;
        this.pageWikipediaParams.loading = false;
        this.pageWikipediaParams.finished = false;
        this.$refs.waterfall && this.$refs.waterfall.resetDefaultData();
        this.navActive = Number(index);
        // 1为儿歌故事 0为奶娃宝典
        if (index == 1) {
          this.classifyName = "最新推荐";
          this.sensorsFn("儿歌故事", "", "", "", "最新推荐");
          this.articleId = 0;
          this.getSong();
        } else {
          this.classifyName = "热门";
          this.sensorsFn("奶娃宝典", "", "", "热门");
          this.articleId = -1;
          // 奶娃宝典需要请求分类数据
          this.getArticlClassify();
        }
        $(".content").css(
          "min-height",
          document.body.clientHeight -
            this.searchHeight -
            this.navHeight -
            $(".fixed").outerHeight(true) +
            1 +
            "px"
        );
      }
      this.$nextTick(() => {
        $(".isDisabled .van-tab").eq(0).removeClass("van-tab--disabled");
      });
    },
    getSong(id) {
      this.pageWikipediaParams.loading = true;
      this.tagList = [
        {
          id: 0,
          fnTagId: "0",
          name: "最新推荐",
        },
        {
          id: 1,
          fnTagId: "1",
          name: "星妈讲故事",
        },
        {
          id: 2,
          fnTagId: "2",
          name: "儿歌动画",
        },
      ];
      this.$http.post(
        "/breedWiki/fairyTales",
        {},
        {
          data: {
            periodId: String(this.periodid), //当前月龄id
            tagId: String(this.articleId != -1 ? this.articleId : 0), //一级分类id
            fnTagId: this.articleId ? this.songTagActiveId : 0, //当前的分类不为最新推荐
          },
          page: this.pageWikipediaParams.page,
          size: this.pageWikipediaParams.size,
        },
        (res) => {
          if (res.code == 200) {
            this.isDisabled = false; //获取数据成功可以切换分类
            this.isNavDisabled = false;
            const { data, total } = res.data;
            this.dataList = [...this.dataList, ...data];
            console.log(this.dataList);
            if (this.dataList.length > this.pageWikipediaParams.size) {
              this.$refs.waterfall.initData("push", data);
            } else {
              this.$refs.waterfall.initData("init", this.dataList);
            }
            this.$nextTick(() => {
              if (this.dataList.length >= total && data) {
                this.pageWikipediaParams.finished = true;
                this.pageWikipediaParams.bottomText =
                  "我们会加油更新的，么么哒~";
              } else {
                this.pageWikipediaParams.page += 1;
                this.pageWikipediaParams.loading = false;
              }
              setTimeout(() => {
                // 判断是否首次进入页面
                if (this.isFirstOpen) {
                  this.isFirstOpen = false;
                  if (this.$route.query.from == "song")
                    $(window).scrollTop(this.positioning + 1);
                }
              }, 500);
            });
            // 神策曝光埋点
            setTimeout(() => {
              babyWikipedia_content.observe(".info", false, {
                classification:
                  this.$refs.tabClassification.activeName || "最新推荐",
                navActive: this.navActive,
              });
            }, 300);
          } else {
            this.$toast("网络异常");
            this.pageWikipediaParams.loading = false;
            this.pageWikipediaParams.error = true;
            this.isDisabled = false;
          }
        },
        null,
        "lucky"
      );
    },
    // 跳转详情
    clickHander(item,type,index) {
      if(!this.isClick) return
      this.isClick = false
      if(item.jumpType){
        sensors.track("xmh5_ziyuanwei_click", {
          ...this.resourceNiche(item),
          xmh5_ziyuanwei_position: index + 1,
        });
        this.isClick = true
        advertisJump(item,this).then(res=>{
          if(res.jumpType === 5){
            this.showVideo = true
            this.isShowComment = true
            this.doctorInfo = {
              ...res,
              contentUrl: res.jumpTargetUrl,
              contentPayUrl: res.jumpTargetUrl,
            }
          }
        })
      }else{
        let audioCollection = [];
        // 0凯琪育儿  1育儿音频  2奶娃百科 ||儿歌动画 3推广活动
        //更改 2凯琪育儿  3育儿音频  1奶娃百科  19推广活动  4儿歌动画
        for (let i = 0; i < this.dataList.length; i++) {
          console.log(this.dataList[i].columnId, "console.log(this.dataList);");
          if (
              this.dataList[i].columnId != null &&
              this.dataList[i].columnId != 1 &&
              this.dataList[i].columnId != 19 &&
              this.dataList[i].columnId != 4
          ) {
            audioCollection.push({
              id: this.dataList[i].id,
              type: this.dataList[i].columnId,
            });
          }
          console.log(this.dataList[i].columnId, "this.dataList[i].columnId");
          console.log(audioCollection.type, "audioCollection");
        }
        sessionStorage.setItem(
            "audioCollection",
            JSON.stringify(audioCollection)
        );
        // 埋点
        let name3 = "",
            name4 = "";
        if (this.navActive) {
          name4 = this.classifyName;
        } else {
          name3 = this.classifyName;
        }
        console.log(item.columnId, "item.type");
        this.sensorsFn(
            "瀑布流内容",
            "",
            "",
            name3,
            name4,
            item.title,
            item.columnId == 2 || item.columnId == 3
                ? "音频"
                : item.columnId == 19
                    ? "其他"
                    : item.columnId == 1 || (item.columnId == 4 && this.navActive)
                        ? "视频"
                        : "图文"
        );
        // 0凯琪育儿  1育儿音频  2奶娃百科 ||儿歌动画 3推广活动
        //更改 2凯琪育儿  3育儿音频  1奶娃百科  19推广活动  4儿歌动画
        switch (Number(item.columnId)) {
          case 1:
            BuiedPointClick_Fn("NewsClick", {
              xmhh5_articletitle_view_pagename: this.$route.meta.title,
              xmhh5_article_title: item.title,
            });
            setTimeout(() => {
              this.isClick=true
              this.$router.push({ path: "/baby/detail/" + item.id });
              item.clickNum +=1
            }, 300);
            break;
          case 4:
            setTimeout(() => {
              this.isClick=true
              this.$router.push({
                name: "parentchildsongsdetail",
                query: {
                  id: item.id,
                },
              });
              this.handleObj = item;
            }, 300);
            break;
          case 19:
            setTimeout(() => {
              this.isClick=true
              location.href = item.contentUrl || item.audioAddress;
            }, 300);
            break;
          default:
            setTimeout(() => {
              this.isClick=true
              this.$router.push({
                path: "/babyWikipedia/audioDetail",
                query: {
                  id: item.id,
                  type: item.columnId,
                  period_id: this.periodid,
                  tag_id: this.navActive
                      ? this.articleId == -1
                          ? 0
                          : this.articleId
                      : this.articleId,
                  navActive: this.navActive,
                  fnTagId: this.articleId ? this.songTagActiveId : 0, //当前的分类不为最新推荐
                },
              });
              item.watchNum += 1;
            }, 300);
        }
      }

    },
    // 独家策划点击
    toSpecialTopic(item) {
      this.sensorsFn("独家策划模块", item.name);
      setTimeout(() => {
        location.href = item.contentUrl;
      }, 200);
    },
    // 编辑推荐点击
    toDetails(item) {
      this.sensorsFn("编辑推荐模块", "", item.title);
      setTimeout(() => {
        location.href = item.contentUrl;
      }, 200);
    },
    // 独家策划
    getExclusivePanning() {
      this.$http.get(
        "/breedWiki/exclusivePlanning",
        { page: 1, size: 5 },
        (res) => {
          if (res.code == "200") {
            this.exclusivePanningList = res.data.data;
            this.getRecommend(); // 编辑推荐接口
          } else {
            this.getRecommend();
          }
        },
        null, 'lucky'
      );
    },
    // 编辑推荐接口
    getRecommend() {
      this.$http.get(
        "/breedWiki/recommend",
        { showLocation: 1 },
        (res) => {
          if (res.code == "200") {
            this.editRecommendList = res.data;
            this.showListNav = true;
            this.$nextTick(() => {
              this.searchHeight = $(".month_search").outerHeight(true);
              this.navHeight = $(".list-nav").outerHeight(true);
              // 分类下拉点击页面定位的距离
              this.positioning =
                $(".list-nav")[0].offsetTop - this.searchHeight + 1;
            });
          } else {
            this.showListNav = true;
            this.$nextTick(() => {
              this.searchHeight = $(".month_search").outerHeight(true);
              this.navHeight = $(".list-nav").outerHeight(true);
            });
          }
        },
        null,
        "lucky"
      );
    },
    // 儿歌故事新增标签分类获取
    getSongClassification() {
      this.$http.get(
        "/breedWiki/getAudioTag",
        { tagId: this.articleId, ageTagId: this.periodid },
        (res) => {
          if (res.code === 200) {
            this.songTagList = res.data;
            this.songTagList.unshift({ name: "全部", id: 0 });
            this.$nextTick(() => {
              this.songTagHeight =
                Math.floor($(".song-classify").outerHeight(true)) - 2;
            });
          }
        },
        null,
        "lucky"
      );
    },

    // 儿歌故事分类选择显示
    showSongClassification() {
      this.showSong = !this.showSong;
      if (this.showSong) {
        sensors.track("home_yunyubaike_tagpop_show", {
          avtag_classification: this.articleId == 1 ? "星妈讲故事" : "儿歌动画",
        });
      }
    },
    // 儿歌故事新增分类标签切换
    switchSongTag(index, classification) {
      this.dataList = [];
      this.$refs.waterfall && this.$refs.waterfall.resetDefaultData();
      this.pageWikipediaParams.page = 1;
      this.songTagActiveId = this.songTagList[index].id;
      this.pageWikipediaParams.loading = true;
      this.pageWikipediaParams.finished = false;
      this.getSong();
      sensors.track(
        classification === "滚动标签"
          ? "home_yunyubaike_tagfloor_click"
          : "home_yunyubaike_tagpop_click",
        {
          avtag_classification: this.articleId == 1 ? "星妈讲故事" : "儿歌动画",
          avtag_name: this.songTagList[index].name,
        }
      );
      // 设置列表的高度 不让点击就滚动顶部
      $(".content").css(
        "min-height",
        document.body.clientHeight -
          this.searchHeight -
          this.navHeight -
          $(".fixed").outerHeight(true) +
          1 +
          "px"
      );
      if (this.suckTheTop) {
        $(window).scrollTop(this.positioning + 1);
      }
    },
    // 返回
    backHander() {
      console.log(this.$route, "this.$route");
      if (this.$route.query.from == "home") {
        this.$router.go(-1);
      } else if (this.$route.query.source == "moreTools") {
        //  this.$router.push({ path: '/moreTools' });
        this.$router.go(-1);
      } else if (this.$route.query.navActive == "2") {
        //  this.$router.push({ path: '/moreTools' });
        this.$router.go(-1);
      } else {
        //  this.$router.push({ path: '/home' });
        location.href = "/home";
      }
      // this.$router.go(-1)
    },
    inputFocusHander() {
      this.sensorsFn("搜索");
      sessionStorage.setItem("searchVal", "babyWikipedia");
      setTimeout(() => {
        this.$router.push({
          path: "/search",
          query: {
            searchIndex: "home",
          },
        });
      });
    },
    sensorsFn(
      type,
      name1 = "",
      name2 = "",
      name3 = "",
      name4 = "",
      name5 = "",
      name6 = ""
    ) {
      sensors.track("xingmahui_yunyubaike_click", {
        yunyubaike_module: type,
        dujiacehua_names: name1,
        bainjitujian_names: name2,
        naiwabaodian_class: "",
        ergegushi_class: "",
        content_title: name5,
        content_type: name6,
        naiwabaodian_class_new: name3,
        ergegushi_class_new: name4,
      });
    },
  },
};
</script>
<style lang="less" scoped>
// /deep/ .exclusive_panning {
//   margin-top: 66px;
// }
/deep/ .month_search {
  transition: all 0.5s;
  position: static;
  background: #ffb2de;
}

.head-bg {
  overflow: hidden;
  width: 100%;
  background: linear-gradient(#ffb2de, #ffb2de, #ffb2de, #ffb2de, #f7f7f7 65%);
}

.wrapper {
  min-height: 100%;
  background: #f7f7f7;
}

.common-pd {
  padding: 0 12px;
}

// 切换导航
.list-nav {
  height: 51px;
  padding: 0 8px;

  /deep/ .van-tab {
    font-weight: bold;
  }

  /deep/ .van-tab__text--ellipsis {
    overflow: visible;
  }

  /deep/ .van-tabs__nav--line {
    width: 100px;
    padding-bottom: 8px;

    .van-tab--active {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
    }
  }

  /deep/ .van-tabs__nav {
    background: transparent;
  }

  /deep/ .van-tab {
    font-size: 14px;
    color: #666666;
  }

  /deep/ .van-tabs__line {
    background: linear-gradient(270deg, #ff67c1 0%, #ff67c1 100%);
    transition-duration: 0s !important;
  }

  /deep/ .van-tabs__wrap {
    height: 51px;
  }
}

.content-list {
  .content {
    margin-top: 8px;
  }

  // 分类
  .classify {
    /deep/ .van-tabs__nav {
      padding: 0 42px 0 0;
      align-items: center;
    }

    /deep/ .van-tabs__line {
      display: none;
    }

    /deep/ .van-tab {
      font-size: 14px;
      margin-left: 8px;
      min-width: 52px;
      height: 34px;
      background: #f7f7f7;
      border-radius: 17px;

      &:nth-of-type(1) {
        margin-left: 0;
      }
    }

    /deep/ .van-tab--active {
      background: linear-gradient(270deg, #ff67c1 0%, #ff67c1 100%);
      // box-shadow: 0px 4px 8px 0px rgba(231, 170, 28, 0.3);
      color: #ffffff;
    }

    /deep/ .van-tabs__wrap {
      height: 50px;
    }
  }

  // 儿歌故事分类
  .song-classify {
    margin-bottom: 8px;

    /deep/ .van-tab--active {
      font-size: 14px;
      color: #ff67c1;
    }

    /deep/ .van-tabs__line {
      width: 20px;
      height: 4px;
      background: linear-gradient(270deg, #ff67c1 0%, #ff67c1 100%);
    }
  }

  // margin-top: 66px;
  height: 100%;
  // background: #ffffff;
  position: relative;

  /deep/ .van-list__finished-text {
    background: transparent;

    img {
      width: 8px;
      height: 8px;
    }
  }

  /deep/ .van-list__loading {
    background: transparent;
  }
  .info-radius{
    border-radius: 4px!important;
  }
  .info{
    position: relative;
  }
  .information-wxtag{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .jumpHeight{
    height: 220px!important;
  }
  // 瀑布流样式
  .info-img {
    position: relative;
    width: 100%;
    height: 100px;
    // min-height: 100px;
    border-radius: 4px 4px 0 0;
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    // img:nth-of-type(1) {
    //   height: auto;
    // }
    .play-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 20px;
      height: 20px;
      display: inline-block;
      background: url("../../../assets/images/nweHome/play.png") no-repeat;
      background-size: contain;
      // z-index: 1;
    }

    .share-btn {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 26px;
      height: 26px;
    }

    .play-status {
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 4px 0px 8px 0px;
      overflow: hidden;

      span {
        padding: 0 4px;
        display: block;
        font-size: 10px;
        font-weight: bold;
        color: #fff;
        line-height: 17px;
        background: rgba(0, 0, 0, 0.4);
      }

      .playing {
        background: linear-gradient(270deg, #f0ba39 0%, #fbcf6f 100%);
      }
    }
  }

  .bottom-content {
    padding: 0 8px;

    .item-title {
      margin-top: 8px;
      font-size: 13px;
      font-weight: bold;
      color: #333;
      line-height: 20px;
      word-break: break-all;
      text-overflow: -o-ellipsis-lastline;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .res_title{
      margin-bottom: 8px;
    }

    .item-tagAndPlaynum {
      margin-top: 4px;
      height: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item-tag {
        height: 20px;
        background: #fedbf0;
        border-radius: 10px;
        font-size: 11px;
        color: #ff67c1;
        line-height: 21px;
        text-align: center;
        padding: 0 8px;
        max-width: 85px;
      }

      .item-playnum {
        height: 27px;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        line-height: 27px;
        font-size: 12px;
        color: #999;

        .icon {
          vertical-align: -11%;
          width: 14px;
          height: 14px;
          margin-right: 3px;
        }
      }
    }
  }
}
</style>
